"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villanuova-sul-clisi": {
    "a38aef1f": [{
      "hkey": "a529d1d8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bostone": [{
      "hkey": "a529d1d8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "villanuova-sul-clisi"
    }],
    "3cba0f10": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "skipSearch": false
    }],
    "calchere": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8281761d": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "skipSearch": false
    }],
    "campagnana": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eee76486": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "skipSearch": false
    }],
    "legnago": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db66c27b": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-della-neve": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bca57149": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "skipSearch": false
    }],
    "milanino-sul-garda": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ec1ad323": [{
      "hkey": "5c56cbe6",
      "slug": "berniga",
      "name": "Berniga",
      "primary": true,
      "skipSearch": false
    }],
    "prandaglio-berniga": [{
      "hkey": "5c56cbe6",
      "slug": "berniga",
      "name": "Berniga",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cd6069a2": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "skipSearch": false
    }],
    "valverde": [{
      "hkey": "43417a36",
      "slug": "villanuova-sul-clisi",
      "name": "Villanuova sul Clisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;